"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Message = _interopRequireDefault(require("../Message"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var nationalDates = {
  'pt-br': {
    '15-9': {
      id: "customer-day",
      title: 'Feliz dia do cliente!',
      image: 'ptBR/customer-day.png',
      alt: 'Dia do cliente'
    },
    '20-9': {
      id: "farroupilha-day",
      title: 'Feliz dia do gaúcho!',
      image: 'ptBR/farroupilha.png',
      alt: 'Dia da Revolução Farroupilha'
    },
    '12-10': {
      id: "nossa-senhora-aparecida",
      title: "Dia de Nossa Senhora Aparecida",
      image: 'ptBR/nossa-senhora-aparecida.png',
      alt: 'Dia de Nossa Senhora Aparecida'
    },
    '15-10': {
      id: "dia-do-professor",
      title: "Dia do professor",
      image: 'ptBR/dia-do-professor.png',
      alt: 'Dia do professor'
    },
    /*'*-10': {
    	id: "pink-october",
    	title: 'Outubro Rosa',
    	image: 'ptBR/pink-october.png',
    	alt: 'Outubro rosa'
    },*/
    '2-11': {
      id: "dia-dos-finados",
      title: "Dia dos Finados",
      image: "ptBR/dia-dos-finados.png",
      alt: "Dia dos Finados"
    },
    '15-11': {
      id: "proclamacao-da-republica",
      title: "Proclamação da República",
      image: "ptBR/proclamacao-da-republica.png",
      alt: "Proclamação da República"
    },
    '20-11': {
      id: "consciencia-negra",
      title: "Consciência Negra",
      image: "ptBR/consciencia-negra.png",
      alt: "Consciência Negra"
    },
    '24-12': {
      id: "natal",
      title: "Natal",
      image: "ptBR/natal.png",
      alt: "Natal"
    },
    '25-12': {
      id: "natal",
      title: "Natal",
      image: "ptBR/natal.png",
      alt: "Natal"
    }
  }
};
var CelebrationMessages = function CelebrationMessages() {
  var _useState = (0, _react.useState)({}),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showDate = _useState2[0],
    setShowDate = _useState2[1];
  (0, _react.useEffect)(function () {
    var today = new Date();
    var tDay = String(today.getDate());
    var tMonth = String(today.getMonth() + 1);
    if (tDay === "1") {
      for (var _i = 0, _Object$values = Object.values(nationalDates["pt-br"]); _i < _Object$values.length; _i++) {
        var _celebrationData = _Object$values[_i];
        localStorage.removeItem("".concat(_celebrationData.id, "-closed"));
      }
    }
    var nationalDate = Object.entries(nationalDates["pt-br"]).find(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 1),
        datePattern = _ref2[0];
      var _datePattern$split = datePattern.split("-"),
        _datePattern$split2 = (0, _slicedToArray2["default"])(_datePattern$split, 2),
        cDay = _datePattern$split2[0],
        cMonth = _datePattern$split2[1];
      return (cDay === "*" || cDay === tDay) && (cMonth === "*" || cMonth === tMonth);
    });
    if (!nationalDate) return;
    var _nationalDate = (0, _slicedToArray2["default"])(nationalDate, 2),
      celebrationData = _nationalDate[1];
    var wasClosed = localStorage.getItem("".concat(celebrationData.id, "-closed")) === "true";
    if (!wasClosed) setShowDate(celebrationData);
  }, []);
  var hide = function hide() {
    localStorage.setItem("".concat(showDate.id, "-closed"), true);
    setShowDate({});
  };
  if (!(showDate !== null && showDate !== void 0 && showDate.id)) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  return /*#__PURE__*/_react["default"].createElement(_Message["default"], {
    visible: !!showDate.title,
    hide: hide,
    title: showDate.title,
    description: /*#__PURE__*/_react["default"].createElement("img", {
      src: require("../../@assets/images/celebrations/".concat(showDate.image)),
      alt: showDate.alt || showDate.title,
      style: {
        width: '30vw'
      }
    })
  });
};
var _default = CelebrationMessages;
exports["default"] = _default;